export class Clarity {
    static set(key: string, value: string) {
        const windowObj = window as any;
        if (windowObj.clarity && typeof windowObj.clarity === "object") {
            windowObj.clarity("set", key, value);
        }
    }
}
